import { useEffect, useState } from "react";

export function SentTime({ minutesAgo }: { minutesAgo: number }) {
    const [time, setTime] = useState("");

    useEffect(() => {
        const _minutesAgo = minutesAgo % (60 * 24);
        const milliSecondsAgo = _minutesAgo * 60 * 1000;
        const date = new Date(Number(new Date()) - milliSecondsAgo);
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        setTime(`${hours}:${minutes}`);
    }, [minutesAgo]);

    return <div>{time}</div>;
}
